module.exports = __webpack_public_path__ + "img/cc-mbs-reta-gray.7c3884e0.png";